import { Flex, Loader } from "@aws-amplify/ui-react";
import { useCallback, useContext } from "react";
import InfoIcon from "@mui/icons-material/Info";
import { CCard } from "@coreui/react";
import Tippy from '@tippyjs/react';

import { ScheduleContext } from "components/maintenanceSchedules/context/ScheduleContext";
import Empty from "components/utils/Empty";
import "./style.css";

const ServiceOrdersAvailable = () => {
  const { availableEvents, setDraggedEvent } = useContext(ScheduleContext);

  const handleDragStart = useCallback(
    (event) => setDraggedEvent(event),
    [setDraggedEvent]
  );

  return availableEvents.loading ? (
    <Loader />
  ) : (
    <CCard className="service-card" borderRadius="medium" variation="outlined">
      {availableEvents.list?.length > 0 ? (
        availableEvents.list?.map((serv) => (
          <Flex className="service-item">
            <div
              draggable="true"
              key={serv.id}
              onDragStart={() => handleDragStart({ id: serv.id })}
            >
              {serv.title}
            </div>
            {serv.description && (
              <Tippy content={serv.description}>
                <InfoIcon color="action" fontSize="small" />
              </Tippy>
            )}
          </Flex>
        ))
      ) : (
        <Empty />
      )}
    </CCard>
  );
};

export default ServiceOrdersAvailable;
